export default {"src":"/_next/static/image/public/assets/platform-logos/word.baefbedd7d66c8e128afb88247a3140c.svg","height":1750,"width":1881};